import { StateObject } from '~src/domains/common/types/common';

const invalidAddressFormSelector = (state: StateObject) =>
  state.invalidAddressForm;

const addressTypeSelector = (state: StateObject) =>
  state.invalidAddress.addressType;

export { invalidAddressFormSelector, addressTypeSelector };
